import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";

export interface ContractorChangeCommandParams {
  ContractorType: CONTRACTOR_TYPES;
  SummaryPrint: boolean;
  ShortName: string;
  Name: string;
  Surname: string;
  TIN: string;
  NationalBusinessRegistryNumber: string;
  Country: string;
  City: string;
  PostalCode: string;
  StreetAndNumber: string;
  ContractorMonit: string;
  IsHidden: boolean;
  IsIndividual: boolean;
  ChargeFromPayer: boolean;
  ImportedContractorId: string | null;
  ContractorProviderId: null | number;
}

export class ContractorChangeCommand extends BaseCommand {
  CommandName = "ContractorChange";
  Command: ContractorChangeCommandParams;
  constructor(sessionId: string, operationId: string, params: ContractorChangeCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
